import { render } from "./AsideMenuList.vue?vue&type=template&id=360506d4"
import script from "./AsideMenuList.vue?vue&type=script&lang=js"
export * from "./AsideMenuList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__